button
    border: none
    background: none
    cursor: pointer

.RangeCalendar
    position: relative
    max-width: 300px
    margin: 0 auto
    .RangeCalendarView
        position: relative
        .FirstDateOverlay
            position: absolute
            top: -10px
            bottom: -10px
            left: -10px
            right: -10px
            display: none
            padding: 20px
            font-weight: 700
            color: rgb($globalSettingsFontPrimary)
            border-radius: $globalSettingsRounding
            background: rgba($globalSettingsFontPrimary, 0.13)
            z-index: 11
        .ShowOverlay
            display: flex
            flex-direction: column
            justify-content: center
            align-items: center
            gap: 10px
            opacity: 0.8
            backdrop-filter: blur(6px)
        .OverlayContent
            display: flex
            justify-content: space-between
            align-items: center
            gap: 10px
            .DateButtonSVG
                stroke: rgb($globalSettingsFontPrimary)

    .DaysOfWeek
        display: grid
        grid-template-columns: repeat(7, 1fr)
        place-items: center
        color: rgb($globalSettingsFontSecondary)
        font-size: 0.7em
        letter-spacing: 0.1em
        font-weight: 700
        text-align: center
        row-gap: 7px
        column-gap: 12px

    /* Positioning the first day */
    .Day
        position: relative
        border: 0
        padding: 0
        width: 30px
        height: 30px
        border-radius: 50%
        display: flex
        align-items: center
        justify-content: center
        color: rgb($globalSettingsFontTertiary)
        font-size: 12px
        font-weight: 400
        box-sizing: border-box
        &:hover, &:focus, &:active
            outline: none

    .ClickToReset
        cursor: default !important

    .Empty
        background: rgb($globalSettingsBackgroundPrimary) !important
        color: rgb($globalSettingsFontTertiary) !important
        border: 0px solid rgb($globalSettingsBackgroundPrimary) !important
        cursor: default

    @keyframes showTooltip
        0%
            display: none
            opacity: 0
        1%
            display: block
            opacity: 0
        100%
            display: block
            opacity: 1

    .Tooltip
        font-size: 12px
        font-weight: 400
        position: absolute
        right: -50px
        bottom: 39px
        width: 120px
        background: rgb($globalSettingsBackgroundPrimary)
        color: rgb($globalSettingsFontPrimary)
        padding: 5px 10px
        border-radius: $globalButtonRounding
        border: 0
        word-break: break-word
        overflow: hidden
        z-index: 21
        box-shadow: 1px 3px 8px 0 rgba($globalSettingsBackgroundShadowColor,0.05), -1px 3px 8px 0 rgba($globalSettingsBackgroundShadowColor,0.05)
        animation: showTooltip 0.3s ease-in-out
        pointer-events: none

    .TooltipMustache
        position: absolute
        right: 2px
        bottom: 20px
        border: 10px solid rgb($globalSettingsBackgroundPrimary)
        border-color: rgb($globalSettingsBackgroundPrimary) transparent transparent transparent
        z-index: 22
        animation: showTooltip 0.3s ease-in-out
        pointer-events: none

    .NotAvailable
        background: rgb($globalSettingsBackgroundSecondary)
        cursor: default

    .NotAllowed
        background: rgb($globalSettingsBackgroundPrimary)
        color: rgb($globalSettingsFontPrimary)
        border: 4px solid rgb($globalCalendarAvailable)
        font-weight: 700
        cursor: default

    .NotAllowedHoverRange, .NotAvailableHoverRange
        color: rgb($globalSettingsBackgroundPrimary)
        border: 4px solid rgb($globalCalendarSelectionBackgroundSecondary) !important
        font-weight: 400
        cursor: default

    .NotAvailableHoverRange
        border: 4px solid rgb($globalSettingsBackgroundTertiary) !important
        background: rgb($globalSettingsBackgroundSecondary) !important
        color: rgb($globalSettingsFontTertiary)

    .LastHoverRange
        background: rgb($globalCalendarSelectionBackgroundQuaternary)

    .Available
        background: rgb($globalCalendarAvailable)
        color: rgb($globalSettingsBackgroundPrimary)
        font-weight: 700
        cursor: pointer
        @media (hover: hover)
            &:hover
                background: rgb($globalCalendarSelectionBackgroundQuaternary)
                color: rgb($globalCalendarSelectionFont)

    .TimeContainer
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 100%
        display: flex
        justify-content: center
        align-items: center
        z-index: 1

    .TimeContainerAvailable
        text-shadow: 1px 1px rgb($globalCalendarAvailable), 0 0 5px rgb($globalCalendarAvailable), 0 0 3px rgb($globalCalendarAvailable), 0 0 1px rgb($globalCalendarAvailable)
        @media (hover: hover)
            &:hover
                text-shadow: 1px 1px rgb($globalCalendarSelectionBackgroundQuaternary), 0 0 5px rgb($globalCalendarSelectionBackgroundQuaternary), 0 0 3px rgb($globalCalendarSelectionBackgroundQuaternary), 0 0 1px rgb($globalCalendarSelectionBackgroundQuaternary)

    .TimeContainerSelected
        text-shadow: 1px 1px rgb($globalCalendarSelectionBackgroundPrimary), 0 0 5px rgb($globalCalendarSelectionBackgroundPrimary), 0 0 3px rgb($globalCalendarSelectionBackgroundPrimary), 0 0 1px rgb($globalCalendarSelectionBackgroundPrimary)

    .DayAddition
        position: absolute
        width: 22px
        height: 22px
        left: 4px
        top: 4px
        border-radius: 50%
        overflow: hidden
        display: flex
        justify-content: center
        align-items: center
        font-weight: 400

    .AvailablePartially
        background:  rgb($globalSettingsBackgroundSecondary)
        color: rgb($globalSettingsFontTertiary)
        clip-path: polygon(100% 100%, 0 100%, 100% 0)

    .AvailablePartiallyHoverRange
        background:  rgb($globalCalendarSelectionBackgroundQuaternary)

    .JumpNextContainer
        left: 0
        right: 0
        top: -50px
        // transform: (translateY(50%))
        position: absolute
        border-radius: $globalButtonRounding
        display: flex
        align-items: center
        justify-content: space-between
        gap: 10px
        padding: 5px 5px
        background: rgb($globalButtonBackgroundPrimary)
        color: rgb($globalButtonFontPrimary)
        stroke: rgba($globalSettingsBackgroundPrimary, 0.8)
        border: 1px solid rgba($globalSettingsFontPrimary, 0.9)
        font-size: 11px
        font-weight: 700
        overflow: hidden
        cursor: pointer
        z-index: 111
        white-space: nowrap
        box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.1), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.1)
        &:hover
            color: rgba($globalSettingsBackgroundPrimary, 0.9)
            stroke: rgba($globalSettingsBackgroundPrimary, 0.9)

    .Selected
        background: rgb($globalCalendarSelectionBackgroundPrimary)
        color: rgb($globalCalendarSelectionFont)
        transition: background 0s, color 0s, visibility 0s
        &.NotAllowed, &.NotAvailable
            border: 4px solid rgb($globalCalendarSelectionBackgroundPrimary)
            background: rgb($globalSettingsBackgroundPrimary)
            color: rgb($globalSettingsFontPrimary)

    .DayInRange
        color: rgb($globalCalendarSelectionFont)
        transition: background 0s, color 0s, visibility 0s

    .Selected.ClickToReset
        @media (hover: hover)
            &:hover
                visibility: hidden
                &:after
                    content: url("data:image/svg+xml,<svg width='28' height='29' viewBox='0 0 28 29' stroke='#{rgb($globalCalendarSelectionFont)}' xmlns='http://www.w3.org/2000/svg'><path d='M6.92893 7.74607L21.0711 21.8882M21.0711 7.74607L6.92893 21.8882'/></svg>")
                    visibility: visible
                    position: absolute
                    width: 30px
                    height: 30px
                    border-radius: 50%
                    display: flex
                    align-items: center
                    justify-content: center
                    background: rgb($globalCalendarSelectionBackgroundPrimary)
                    color: rgb($globalCalendarSelectionFont)
                    font-size: 12px
                    font-weight: 700

    .Today
        text-decoration: underline

    .InRange
        background: rgb($globalCalendarSelectionBackgroundQuaternary)
        padding: 0 10px
        margin: 0 -10px
        border-radius: 5px

    .InRangeNotAvailable
        background: rgb($globalSettingsBackgroundTertiary) !important

    .InRangeLeftRound
        padding: 0 10px 0 0
        margin: 0 -10px 0 0
        border-radius: 15px 5px 5px 15px

    .InRangeRightRound
        padding: 0 0 0 10px
        margin: 0 0 0 -10px
        border-radius: 5px 15px 15px 5px

    .InRangeLastPossible
        background: linear-gradient(to right, rgb($globalCalendarSelectionBackgroundQuaternary) 0%, rgb($globalCalendarSelectionBackgroundQuaternary) 50%, rgb($globalSettingsBackgroundTertiary) 51%, rgb($globalSettingsBackgroundTertiary) 100%) !important

    .DayWrapper
        position: relative

    .NoTransition
        transition: background 0s

    .Hovered
        background: rgb($globalCalendarSelectionBackgroundSecondary) !important
        color: rgb($globalSettingsBackgroundPrimary) !important

    .InHoverRange
        background: rgb($globalCalendarSelectionBackgroundQuaternary)
        padding: 0 10px
        margin: 0 -10px
        border-radius: 5px

    .InHoverRangeLeftRound
        padding: 0 10px 0 0
        margin: 0 -10px 0 0
        border-radius: 15px 5px 5px 15px

    .InHoverRangeRightRound
        padding: 0 0 0 10px
        margin: 0 0 0 -10px
        border-radius: 5px 15px 15px 5px

    .DatesContainer
        flex: 1
        display: flex
        flex-direction: row
        align-items: center
        justify-content: space-between

    @media #{$mobile}
        .DatesContainer
            justify-content: center
        .SecondDaysContainer
            display: none

    .DateGrid
        display: grid
        grid-template-columns: repeat(7, 1fr)
        place-items: center
        row-gap: 7px
        column-gap: 12px

    .DateGridContainer
        min-height: 215px

    .NavContainer
        width: 100%
        display: flex
        flex-direction: row
        align-items: stretch
        justify-content: space-between
        gap: 10px

    .NavButton
        padding: 8px

        &:disabled
            opacity: 0.5
            background: none

    .MonthIndicator
        color: rgb($globalSettingsFontPrimary)
        text-align: center
        font-weight: 500
        padding: .5em 1em
        flex-grow: 1

        &:not(:disabled)
            &:hover, &:focus-visible
                background: rgb($globalSettingsBackgroundSecondary)

.DoubleColumn
    max-width: 620px

.ArrowSvg
    stroke: rgb($globalSettingsFontSecondary)

.view-switch
    color: rgb($globalSettingsFontPrimary)
    text-align: center
    font-weight: 500
    padding: .5em 1em
    flex-grow: 1
    display: flex
    flex-direction: row
    align-items: center
    justify-content: center

    \time
        display: flex
        flex-grow: 1
        align-items: center
        justify-content: center
        gap: 10px
        .viewSwitchItem
            display: flex
            align-items: center
            justify-content: center
            flex-basis: 50%
        .viewSwitchItemMultiple
            &:nth-of-type(2)
                display: none

@media #{$tablet}
    .view-switch
        \time
            .viewSwitchItemMultiple
                display: flex
                align-items: center
                justify-content: center
                flex-basis: 50%
                &:first-of-type
                    padding-right: 50px
                &:nth-of-type(2)
                    padding-left: 50px
                    display: initial

.yearView, .decadeView
    display: grid
    grid-template-columns: repeat(3, 1fr)
    grid-template-rows: repeat(4, 1fr)
    grid-gap: 1em

    & > button
        border: 0
        background: rgb($globalSettingsBackgroundPrimary)
        color: rgb($globalSettingsFontPrimary)
        font-weight: 700
        font-size: 1.2em
        border-radius: 5px
        padding: .7em 0.5em

        &:not(:disabled)
            &:hover, &:focus-visible
                background: rgb($globalCalendarSelectionBackgroundSecondary)
                color: rgb($globalCalendarSelectionFont)

        &:disabled
            background: rgb($globalSettingsBackgroundPrimary)
            color: rgb($globalSettingsFontTertiary)
            font-weight: 400

        &.selected
            outline: 1px solid rgb($globalSettingsFontPrimary) !important

.monthsContainer
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    .monthView
        max-width: 300px
        flex-grow: 1
